import { render, staticRenderFns } from "./QuiSommesNous.vue?vue&type=template&id=2f64ef4b&scoped=true&"
import script from "./QuiSommesNous.vue?vue&type=script&lang=js&"
export * from "./QuiSommesNous.vue?vue&type=script&lang=js&"
import style0 from "./QuiSommesNous.vue?vue&type=style&index=0&id=2f64ef4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f64ef4b",
  null
  
)

export default component.exports